(function () {
  var LOGO =
    'https://cdn.shopify.com/s/files/1/0637/4460/6375/files/Header-Logo-New.svg?v=1729066833';
  var CLINICIANS_LOGO =
    'https://cdn.shopify.com/s/files/1/0637/4460/6375/files/clinicians-choice.png?v=1776653501';
  var REVIEW_COUNT = '22,104';

  var TOTAL_STEPS = 7;

  var DOCTORS = {
    amy: {
      name: 'Dr. Amy Shah',
      cred: 'Double board-certified MD: nutrition, immunology & hormone health',
      photo:
        'https://cdn.shopify.com/s/files/1/0637/4460/6375/files/longevity-pdp-dr-amy-shah.png?v=1778814965',
      initials: 'AS',
    },
    devkota: {
      name: 'Dr. Suzanne Devkota',
      cred: 'Director of Microbiome Research, Cedars-Sinai',
      photo:
        'https://cdn.shopify.com/s/files/1/0637/4460/6375/files/Frame_1000004731.png?v=1727767462',
      initials: 'SD',
    },
    suppiah: {
      name: 'Dr. Ara Suppiah',
      cred: 'Physician to seven World No. 1 golfers · Head of Medical, LIV Golf',
      initials: 'AS',
    },
    dshah: {
      name: 'Dr. Darshan Shah',
      cred: 'Longevity Medicine Physician · 20,000+ procedures performed',
      photo:
        'https://cdn.shopify.com/s/files/1/0637/4460/6375/files/longevity-pdp-dr-darshan-shah.png?v=1778814965',
      initials: 'DS',
    },
    mussallem: {
      name: 'Dr. Dawn Mussallem',
      cred: 'Integrative Oncologist',
      photo: 'https://cdn.shopify.com/s/files/1/0637/4460/6375/files/dawn_1.jpg?v=1777537999',
      initials: 'DM',
    },
  };

  var AMBASSADORS = [
    {
      name: 'Aryna Sabalenka',
      cred: 'World No. 1 Tennis Player · 4x Grand Slam Champion',
      role: 'Global Ambassador & Shareholder',
      photo:
        'https://cdn.shopify.com/s/files/1/0637/4460/6375/files/BURGUNDY_SHOT_03_IM8_ARYNA_0228-min-fb-square-1200-1200.jpg?v=1741754349',
    },
    {
      name: 'Giannis Antetokounmpo',
      cred: 'NBA Champion · 2x MVP & 10x NBA All-Star',
      role: 'Global Ambassador & Shareholder',
      photo: 'https://cdn.shopify.com/s/files/1/0637/4460/6375/files/giannis-hero-1.jpg?v=1776500902',
    },
    {
      name: 'Ollie Bearman',
      cred: 'Formula 1 Driver',
      role: 'Global Ambassador & Shareholder',
      photo: 'https://cdn.shopify.com/s/files/1/0637/4460/6375/files/ollie-hero-1.jpg?v=1776500902',
    },
    {
      name: 'Jay Shetty',
      cred: '#1 New York Times Bestselling Author · Host, On Purpose',
      role: 'Global Ambassador',
      photo: 'https://cdn.shopify.com/s/files/1/0637/4460/6375/files/press_jay_1.jpg?v=1729066833',
    },
  ];

  var SAB_QUOTE =
    '“My personal journey — from battling stage IV cancer to undergoing a heart transplant — taught me the importance of resilience and integrative health. I joined IM8 to inspire others and contribute to life-changing products that support the body\u2019s ability to heal and thrive.”';
  var SAB_QUOTE_BY = '— Dr. Dawn Mussallem · Integrative Oncologist';

  var QUESTIONS = [
    {
      tag: 'Q1 · Primary goal',
      title: 'What matters most to you right now?',
      micro:
        'One serving of Daily Ultimate Essentials Pro replaces 16 supplements in one sachet. In a 12-week Randomized Controlled Trial (NCT06655597): 95% reported more energy, 85% better digestion, 80% better sleep.',
      attr: null,
      opts: [
        { label: 'Daily energy & focus', e: 2, goal: 'energy' },
        { label: 'Digestion & gut comfort', e: 2, goal: 'digestion' },
        { label: 'Immunity & resilience', e: 2, goal: 'immunity' },
        { label: 'Sleep & recovery', e: 2, goal: 'sleep' },
        { label: 'Healthy aging & cellular health', l: 2, goal: 'aging' },
        { label: 'All of it — today and long-term', e: 1, l: 1, stack: true, goal: 'all' },
      ],
    },
    {
      tag: 'Q2 · Age',
      title: 'Your age?',
      micro:
        "Aging isn't one thing — science now maps it as 12 measurable hallmarks. Daily Ultimate Longevity is the only system built to target every one.",
      attr: 'Dr. Darshan Shah, Longevity Clinician · IM8 Scientific Advisory Board Member',
      opts: [
        { label: 'Under 30', e: 1 },
        { label: '30–39', l: 1 },
        { label: '40–49', l: 2 },
        { label: '50+', l: 2 },
      ],
    },
    {
      tag: 'Q3 · Your routine',
      title: 'How many supplements are you taking today?',
      micro:
        'Daily Ultimate Essentials Pro replaces 16 supplements in one daily drink — 90 clinically-dosed ingredients, free from 280 banned substances & 300+ clinicians share IM8 on FrontrowMD without compensation.',
      attr: null,
      opts: [
        { label: 'None — starting fresh', e: 1 },
        { label: '1–3', e: 1 },
        { label: '4–9', e: 2 },
        { label: '10+ — a full countertop', e: 2 },
      ],
    },
    {
      tag: 'Q4 · Your timeline',
      title: 'Which sounds more like you?',
      micro:
        'Daily Ultimate Essentials Pro delivers energy you can feel — 95% of users reported more in a 12-week trial. Longevity works deeper: one NAD+ system targeting all 12 hallmarks of aging, with 10 clinically studied compounds including 600mg Cellular Protection Activator and 610mg NAD+ Energy Booster.',
      attr: null,
      opts: [
        { label: '“Help me feel better today”', e: 2 },
        { label: '“Help me invest in the next decade”', l: 2 },
        { label: '“Both, honestly”', stack: true },
      ],
    },
    {
      tag: 'Q5 · Your training',
      title: 'How often do you train?',
      micro:
        "Daily Ultimate Essentials Pro is NSF Certified for Sport® — independently tested and screened for 280+ substances banned in professional sport. It's the standard elite athletes hold their supplements to.",
      attr: 'Trusted by Aryna Sabalenka · Giannis Antetokounmpo · Oliver Bearman · Inter Miami CF',
      opts: [
        { label: '5+ days a week', e: 1 },
        { label: '2–4 days a week', e: 1 },
        { label: 'Once a week or less' },
      ],
    },
    {
      tag: 'Q7 · Your commitment',
      title: 'One supplement, or the full system?',
      micro:
        'Foundational nutrition covers how you feel today. Longevity science works on how you age for years to come. The Beckham Stack is both in one routine — the same foundation-to-longevity approach David Beckham built IM8 around.',
      attr: null,
      opts: [
        {
          label: 'Keep it simple — one daily supplement that does the heavy lifting',
          guard: true,
        },
        {
          label:
            'Go all in — the full system, foundation for today plus longevity for tomorrow',
          stack: true,
        },
        { label: 'Not sure — match me to what fits' },
      ],
    },
  ];

  var RESULTS = {
    ep: {
      name: 'Daily Ultimate Essentials Pro',
      eye: 'All-in-one daily nutrition',
      whyTpl:
        'You told us {{goal}} comes first — and that a routine only works if it stays simple. Daily Ultimate Essentials Pro puts 90 clinically-dosed ingredients across 9 organ systems into one daily drink, replacing 16 capsules. Built to power your daily performance.†',
      url: '/products/essentials-pro?selling_plan=2948432039',
      pills: [
        'Replaces 16 supplements in one daily drink',
        'NSF Certified for Sport',
        '90 clinically-dosed ingredients — no hidden dosages',
        '90-day money-back guarantee',
      ],
      price: '$XX',
      billed: 'Billed $XXX.XX USD every 12 weeks',
      day: '$X.XX USD / DAY',
      priceNote: null,
      up: {
        body: "Add Daily Ultimate Longevity — nutrition today, longevity tomorrow. The complete daily system, and David Beckham's actual protocol.",
        offerKey: 'stack',
      },
      hero:
        'https://cdn.shopify.com/s/files/1/0637/4460/6375/files/beckham.jpg?v=1776607297',
    },
    lg: {
      name: 'Daily Ultimate Longevity',
      eye: 'Advanced healthy-aging system',
      whyTpl:
        "You're {{age}} and investing before symptoms — exactly who this formula was made for. A 5-complex system delivers NMN, spermidine, fisetin, quercetin and resveratrol in one daily sachet, targeting aging at the cellular level.†",
      url: '/products/longevity?selling_plan=2948432039',
      pills: [
        'Targets all 12 hallmarks of aging',
        '10 clinically studied compounds',
        'One NAD+ system — one daily sachet',
        '90-day money-back guarantee',
      ],
      price: '$XX',
      billed: 'Billed $XXX.XX USD every 12 weeks',
      day: '$X.XX USD / DAY',
      priceNote: null,
      up: {
        body: 'Add Daily Ultimate Essentials Pro — your 90-ingredient daily foundation. Together: the complete daily system, nutrition today and longevity tomorrow.',
        offerKey: 'ep',
      },
      hero:
        'https://cdn.shopify.com/s/files/1/0637/4460/6375/files/beckham.jpg?v=1776607297',
    },
    stack: {
      name: 'The Beckham Stack',
      eye: 'Essentials Pro + Longevity set',
      whyTpl:
        'You want both — {{goal}} now, and healthy aging for the long run. Daily Ultimate Essentials Pro\'s 90 ingredients across 9 organ systems, plus Daily Ultimate Longevity targeting all 12 hallmarks of aging.† Two servings a day. Nothing else to figure out.',
      url: '/products/the-beckham-stack-pro?selling_plan=2948432039',
      pills: [
        'The complete daily system — nutrition today, longevity tomorrow',
        'NSF Certified for Sport',
        'Replaces a countertop of supplements — about the price of a coffee a day',
        '90-day money-back guarantee',
      ],
      price: '$XX',
      billed: 'Billed $XXX.XX USD every 12 weeks',
      day: '$X.XX USD / DAY',
      priceNote: null,
      up: null,
      note: 'Inside your Stack — Daily Ultimate Essentials Pro + Daily Ultimate Longevity.',
      hero:
        'https://cdn.shopify.com/s/files/1/0637/4460/6375/files/beckham.jpg?v=1776607297',
    },
  };

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getGoalKey(ans) {
    if (ans[0] == null) return 'all';
    return QUESTIONS[0].opts[ans[0]].goal || 'all';
  }

  function getDoctorCards(ans) {
    var goalKey = getGoalKey(ans);
    var map = {
      energy: 'amy',
      immunity: 'amy',
      digestion: 'devkota',
      sleep: 'suppiah',
      aging: 'dshah',
      all: 'dshah',
    };
    var k1 = map[goalKey] || 'amy';
    var k2 = k1 === 'devkota' ? 'amy' : 'devkota';
    return [DOCTORS[k1], DOCTORS[k2], DOCTORS.mussallem];
  }

  function getProgress(state) {
    var stepIndex;
    if (state.step === 'amb' || state.step === 'sab') stepIndex = 5;
    else if (state.qi === 5) stepIndex = 6;
    else stepIndex = state.qi;

    return {
      label: stepIndex + 1 + ' of ' + TOTAL_STEPS,
      pct: Math.round((stepIndex / TOTAL_STEPS) * 100),
    };
  }

  function renderPersonCard(person, showRole) {
    var avatar = person.photo
      ? '<img class="im8-welcome-quiz__person-photo" src="' +
        esc(person.photo) +
        '" alt="' +
        esc(person.name) +
        '">'
      : '<span class="im8-welcome-quiz__person-photo im8-welcome-quiz__person-photo--placeholder" aria-hidden="true">' +
        esc(person.initials || person.name.charAt(0)) +
        '</span>';

    return (
      '<div class="im8-welcome-quiz__person-card">' +
      avatar +
      '<div class="im8-welcome-quiz__person-copy">' +
      '<div class="im8-welcome-quiz__person-name">' +
      esc(person.name) +
      '</div>' +
      '<div class="im8-welcome-quiz__person-cred">' +
      esc(person.cred) +
      '</div>' +
      (showRole && person.role
        ? '<div class="im8-welcome-quiz__person-role">' + esc(person.role) + '</div>'
        : '') +
      '</div>' +
      '</div>'
    );
  }

  function renderSlideChrome(progress) {
    return (
      '<div class="im8-welcome-quiz__quiz-top">' +
      '<button type="button" class="im8-welcome-quiz__back" data-action="back" aria-label="Back">←</button>' +
      '<img class="im8-welcome-quiz__quiz-logo" src="' +
      LOGO +
      '" alt="I·M·8">' +
      '<div class="im8-welcome-quiz__step">' +
      esc(progress.label) +
      '</div>' +
      '</div>' +
      '<div class="im8-welcome-quiz__progress-track"><div class="im8-welcome-quiz__progress-fill" style="width:' +
      progress.pct +
      '%"></div></div>'
    );
  }

  function route(ans) {
    var e = 0;
    var l = 0;
    var stack = false;
    var guard = false;

    ans.forEach(function (ai, qi) {
      var o = QUESTIONS[qi].opts[ai];
      if (!o) return;
      e += o.e || 0;
      l += o.l || 0;
      if (o.stack) stack = true;
      if (o.guard) guard = true;
    });

    if (guard) return e >= l ? 'ep' : 'lg';
    if (stack) return 'stack';
    if (e >= 3 && l >= 3) return 'stack';
    if (e > l) return 'ep';
    if (l > e) return 'lg';
    return 'stack';
  }

  function buildResult(ans, config) {
    var out = route(ans);
    var goal =
      ans[0] != null && ans[0] < 5
        ? QUESTIONS[0].opts[ans[0]].label.toLowerCase()
        : 'your daily performance';
    var ages = ['under 30', 'in your 30s', 'in your 40s', 'in your 50s or beyond'];
    var age = ans[1] != null ? ages[ans[1]] : 'planning ahead';
    var base = RESULTS[out];
    var why = base.whyTpl.replace('{{goal}}', goal).replace('{{age}}', age);
    var offer = (config && config.offers && config.offers[out]) || {};
    return Object.assign({ out: out, why: why }, base, {
      price: offer.price || base.price,
      billed: offer.billed || base.billed,
      day: offer.day || base.day,
      variantId: offer.variantId || null,
      sellingPlanId: offer.sellingPlanId || null,
      url: offer.url || base.url,
      savePct: offer.savePct,
      priceNote: offer.variantId ? null : base.priceNote,
    });
  }

  function WelcomeQuiz(root, config) {
    this.root = root;
    this.config = config || {};
    this.state = { step: 'intro', qi: 0, ans: [], sel: null };
    this.root.addEventListener('click', this.onClick.bind(this));
    this.render();
  }

  WelcomeQuiz.prototype.onClick = function (e) {
    var t = e.target.closest('[data-action]');
    if (!t || !this.root.contains(t)) return;

    var action = t.getAttribute('data-action');
    if (action === 'start') this.start();
    if (action === 'back') this.back();
    if (action === 'restart') this.restart();
    if (action === 'pick') this.pick(Number(t.getAttribute('data-index')));
    if (action === 'amb-next') this.ambNext();
    if (action === 'sab-next') this.sabNext();
    if (action === 'add-to-cart') this.addOfferToCart(this.state.ans, t);
    if (action === 'upsell-cart') {
      this.addOfferToCart(this.state.ans, t, t.getAttribute('data-offer') || 'stack');
    }
  };

  WelcomeQuiz.prototype.getOffer = function (key) {
    return (this.config.offers && this.config.offers[key]) || {};
  };

  WelcomeQuiz.prototype.addOfferToCart = function (ans, button, offerKey) {
    if (this._addingToCart) return;
    var key = offerKey || buildResult(ans, this.config).out;
    var offer = this.getOffer(key);
    if (!offer.variantId) {
      if (offer.url) window.location.href = offer.url;
      return;
    }

    this._addingToCart = true;
    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
    }

    var cartDrawer = document.querySelector('cart-drawer');
    var mainItem = { id: Number(offer.variantId), quantity: 1 };
    if (offer.sellingPlanId) mainItem.selling_plan = Number(offer.sellingPlanId);
    var sectionIds = [];
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sectionIds = cartDrawer.getSectionsToRender().map(function (s) {
        return s.id;
      });
    }

    // IM8Cart (global.js): Standard Actions first, guarded Ajax second.
    // Resolves to the /cart/add.js contract so the handlers below are unchanged.
    window.IM8Cart.add([mainItem], { sections: sectionIds, context: 'product' })
      .then(
        function (data) {
          if (data && data.status) {
            throw new Error(data.description || data.message || 'Could not add to cart');
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'im8-welcome-quiz',
              cartData: data,
              eventType: typeof EVENT_TYPE !== 'undefined' && EVENT_TYPE.add ? EVENT_TYPE.add : 'add',
            });
          }

          if (button) {
            button.classList.remove('is-loading');
            button.classList.add('is-success');
          }

          if (cartDrawer && data.sections && Object.keys(data.sections).length) {
            cartDrawer.renderContents(data);
            if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
          } else if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          console.error('[im8-welcome-quiz] cart add failed:', err);
          if (window.IM8CartGuard && err && (err.cartBlocked || err.name === 'AbortError')) {
            // Bot-protection challenge / hung edge: hand the add to a GET
            // permalink so the user clears the challenge once.
            window.IM8CartGuard.recoverViaNavigation(mainItem, { returnTo: '/cart' });
            return;
          }
          if (offer.url) window.location.href = offer.url;
        }.bind(this)
      )
      .finally(
        function () {
          this._addingToCart = false;
          if (button) button.disabled = false;
        }.bind(this)
      );
  };

  WelcomeQuiz.prototype.start = function () {
    this.state = { step: 'q', qi: 0, ans: [], sel: null };
    this.render();
  };

  WelcomeQuiz.prototype.restart = function () {
    this.state = { step: 'intro', qi: 0, ans: [], sel: null };
    this.render();
  };

  WelcomeQuiz.prototype.back = function () {
    var s = this.state;
    if (s.step === 'sab') {
      s.step = 'amb';
      s.sel = null;
    } else if (s.step === 'amb') {
      s.step = 'q';
      s.qi = 4;
      s.sel = null;
    } else if (s.step === 'q') {
      if (s.qi === 0) {
        s.step = 'intro';
        s.sel = null;
      } else if (s.qi === 5) {
        s.step = 'sab';
        s.sel = null;
      } else {
        s.qi -= 1;
        s.sel = null;
      }
    }
    this.render();
  };

  WelcomeQuiz.prototype.ambNext = function () {
    this.state.step = 'sab';
    this.state.sel = null;
    this.render();
  };

  WelcomeQuiz.prototype.sabNext = function () {
    this.state.step = 'q';
    this.state.qi = 5;
    this.state.sel = null;
    this.render();
  };

  WelcomeQuiz.prototype.pick = function (index) {
    var s = this.state;
    if (s.step !== 'q' || s.sel !== null) return;
    var ans = s.ans.slice();
    ans[s.qi] = index;
    s.sel = index;
    s.ans = ans;
    this.render();

    var self = this;
    setTimeout(function () {
      if (self.state.qi === 5) {
        self.state.step = 'calc';
        self.state.sel = null;
        self.render();
        setTimeout(function () {
          self.state.step = 'result';
          self.state.sel = null;
          self.render();
        }, self.config.interstitialMs || 1400);
      } else if (self.state.qi === 4) {
        self.state.step = 'amb';
        self.state.sel = null;
        self.render();
      } else {
        self.state.qi += 1;
        self.state.sel = null;
        self.render();
      }
    }, 240);
  };

  WelcomeQuiz.prototype.renderIntro = function () {
    var c = this.config;
    return (
      '<div class="im8-welcome-quiz__intro">' +
      '<div class="im8-welcome-quiz__hero">' +
      '<img class="im8-welcome-quiz__hero-bg" src="' +
      esc(c.heroSrc) +
      '" alt="' +
      esc(c.heroAlt) +
      '" loading="eager" fetchpriority="high">' +
      '<div class="im8-welcome-quiz__hero-shade" aria-hidden="true"></div>' +
      '<img class="im8-welcome-quiz__logo" src="' +
      esc(c.logoSrc) +
      '" alt="' +
      esc(c.logoAlt) +
      '">' +
      '</div>' +
      '<div class="im8-welcome-quiz__body">' +
      '<div class="im8-welcome-quiz__copy">' +
      '<p class="im8-welcome-quiz__eyebrow">' +
      esc(c.eyebrow) +
      '</p>' +
      '<h1 class="im8-welcome-quiz__headline">' +
      esc(c.headline) +
      '</h1>' +
      '<p class="im8-welcome-quiz__description">' +
      esc(c.description) +
      '</p>' +
      '</div>' +
      '<div class="im8-welcome-quiz__cta">' +
      '<button type="button" class="im8-welcome-quiz__start" data-action="start">' +
      esc(c.ctaLabel) +
      '</button>' +
      '<p class="im8-welcome-quiz__credibility">' +
      esc(c.credibilityLine) +
      '</p>' +
      '</div>' +
      '</div>' +
      '</div>'
    );
  };

  WelcomeQuiz.prototype.renderQuiz = function () {
    var s = this.state;
    var q = QUESTIONS[s.qi];
    var progress = getProgress(s);
    var opts = q.opts
      .map(function (o, i) {
        var sel = s.sel === i;
        return (
          '<button type="button" class="im8-welcome-quiz__option' +
          (sel ? ' is-selected' : '') +
          '" data-action="pick" data-index="' +
          i +
          '">' +
          esc(o.label) +
          '</button>'
        );
      })
      .join('');

    var edu =
      this.config.showEducation !== false
        ? '<div class="im8-welcome-quiz__edu">' +
          '<div class="im8-welcome-quiz__edu-label">Why it matters</div>' +
          '<div class="im8-welcome-quiz__edu-body">' +
          esc(q.micro) +
          '</div>' +
          (q.attr
            ? '<div class="im8-welcome-quiz__edu-attr">' + esc(q.attr) + '</div>'
            : '') +
          '</div>'
        : '';

    return (
      '<div class="im8-welcome-quiz__quiz">' +
      renderSlideChrome(progress) +
      '<div class="im8-welcome-quiz__quiz-scroll">' +
      '<div class="im8-welcome-quiz__q-tag">' +
      esc(q.tag) +
      '</div>' +
      '<h2 class="im8-welcome-quiz__q-title">' +
      esc(q.title) +
      '</h2>' +
      '<div class="im8-welcome-quiz__options">' +
      opts +
      '</div>' +
      edu +
      '</div>' +
      '</div>'
    );
  };

  WelcomeQuiz.prototype.renderAmbassadors = function () {
    var progress = getProgress(this.state);
    var self = this;
    var cards = AMBASSADORS.map(function (a) {
      var person = a;
      if (a.name === 'Aryna Sabalenka' && self.config.arynaPhoto) {
        person = Object.assign({}, a, { photo: self.config.arynaPhoto });
      } else if (a.name === 'Jay Shetty' && self.config.jayShettyPhoto) {
        person = Object.assign({}, a, { photo: self.config.jayShettyPhoto });
      }
      return renderPersonCard(person, true);
    }).join('');

    return (
      '<div class="im8-welcome-quiz__quiz">' +
      renderSlideChrome(progress) +
      '<div class="im8-welcome-quiz__quiz-scroll">' +
      '<div class="im8-welcome-quiz__q-tag">Global Ambassadors</div>' +
      '<h2 class="im8-welcome-quiz__q-title">Trusted at the highest level.</h2>' +
      '<p class="im8-welcome-quiz__slide-copy">Athletes and voices who hold their daily routine to a professional standard — and put their names on IM8.</p>' +
      '<div class="im8-welcome-quiz__person-list">' +
      cards +
      '</div>' +
      '<button type="button" class="im8-welcome-quiz__start im8-welcome-quiz__slide-cta" data-action="amb-next">Continue</button>' +
      '</div>' +
      '</div>'
    );
  };

  WelcomeQuiz.prototype.renderDoctors = function () {
    var progress = getProgress(this.state);
    var self = this;
    var cards = getDoctorCards(this.state.ans)
      .map(function (d) {
        var person = d;
        if (d.name === 'Dr. Dawn Mussallem' && self.config.drDawnPhoto) {
          person = Object.assign({}, d, { photo: self.config.drDawnPhoto });
        }
        return renderPersonCard(person, false);
      })
      .join('');

    return (
      '<div class="im8-welcome-quiz__quiz">' +
      renderSlideChrome(progress) +
      '<div class="im8-welcome-quiz__quiz-scroll">' +
      '<div class="im8-welcome-quiz__q-tag">Before your result</div>' +
      '<h2 class="im8-welcome-quiz__q-title">Built by people who don’t guess.</h2>' +
      '<p class="im8-welcome-quiz__slide-copy">Every IM8 formula is developed with our Scientific Advisory Board — physicians and scientists from Cedars-Sinai and NASA, alongside leaders in longevity, microbiome science and sports medicine.</p>' +
      '<div class="im8-welcome-quiz__person-list">' +
      cards +
      '</div>' +
      '<blockquote class="im8-welcome-quiz__slide-quote">' +
      esc(SAB_QUOTE) +
      '</blockquote>' +
      '<div class="im8-welcome-quiz__slide-quote-by">' +
      esc(SAB_QUOTE_BY) +
      '</div>' +
      '<button type="button" class="im8-welcome-quiz__start im8-welcome-quiz__slide-cta" data-action="sab-next">One last question</button>' +
      '</div>' +
      '</div>'
    );
  };

  WelcomeQuiz.prototype.renderCalc = function () {
    return (
      '<div class="im8-welcome-quiz__calc">' +
      // Non-breaking space keeps the node out of theme `div:empty { display:none }`.
      '<div class="im8-welcome-quiz__spinner" role="status" aria-label="Loading">\u00a0</div>' +
      '<div class="im8-welcome-quiz__calc-title">Building your protocol</div>' +
      '<p class="im8-welcome-quiz__calc-copy">Developed with the IM8 Scientific Advisory Board — Cedars-Sinai · NASA</p>' +
      '</div>'
    );
  };

  WelcomeQuiz.prototype.renderResult = function () {
    var r = buildResult(this.state.ans, this.config);
    var saveLabel = r.savePct ? 'Save ' + r.savePct + '%' : 'Save 30%';
    var pills = r.pills
      .map(function (p) {
        return (
          '<span class="im8-welcome-quiz__pill"><span class="im8-welcome-quiz__pill-check">✓</span>' +
          esc(p) +
          '</span>'
        );
      })
      .join('');

    var upsellKey = r.up ? r.up.offerKey || 'stack' : 'stack';
    var upsellTitle =
      upsellKey === 'ep' ? 'Add Daily Ultimate Essentials Pro' : 'Get the Beckham Stack';
    var upsellCta =
      upsellKey === 'ep' ? 'Add Essentials Pro →' : 'Get the Beckham Stack →';
    var up = r.up
      ? '<div class="im8-welcome-quiz__upsell">' +
        '<div class="im8-welcome-quiz__upsell-tag">Maximize your results</div>' +
        '<div class="im8-welcome-quiz__upsell-title">' +
        esc(upsellTitle) +
        '</div>' +
        '<p class="im8-welcome-quiz__upsell-body">' +
        esc(r.up.body) +
        '</p>' +
        '<button type="button" class="im8-welcome-quiz__upsell-btn" data-action="upsell-cart" data-offer="' +
        esc(upsellKey) +
        '">' +
        esc(upsellCta) +
        '</button>' +
        '</div>'
      : '';

    var priceNote = r.priceNote
      ? '<div class="im8-welcome-quiz__price-note">' + esc(r.priceNote) + '</div>'
      : '';
    var note = r.note
      ? '<p class="im8-welcome-quiz__result-note">' + esc(r.note) + '</p>'
      : '';

    var hero =
      '<div class="im8-welcome-quiz__result-hero">' +
      '<img src="' +
      esc(r.hero) +
      '" alt="' +
      esc(r.name) +
      '">' +
      '<div class="im8-welcome-quiz__clinicians">' +
      '<img class="im8-welcome-quiz__clinicians-logo" src="' +
      CLINICIANS_LOGO +
      '" alt="Clinicians\' Choice" width="116" height="38" loading="lazy">' +
      '<div class="im8-welcome-quiz__clinicians-copy"><strong>313 clinicians</strong> share this on <em>FrontrowMD</em> without compensation.</div>' +
      '</div>' +
      '</div>';

    var plan =
      '<div class="im8-welcome-quiz__subscribe-label">Subscribe &amp; save:</div>' +
      '<div class="im8-welcome-quiz__plan">' +
      '<div class="im8-welcome-quiz__plan-badge">Best value</div>' +
      '<div class="im8-welcome-quiz__plan-row"><span class="im8-welcome-quiz__plan-radio"></span><span class="im8-welcome-quiz__plan-name">90-Day Supply</span><span class="im8-welcome-quiz__plan-save">' +
      esc(saveLabel) +
      '</span></div>' +
      '<div class="im8-welcome-quiz__plan-prices"><span><span class="im8-welcome-quiz__plan-price">' +
      esc(r.price) +
      '</span><span class="im8-welcome-quiz__plan-per">/mo</span></span><span class="im8-welcome-quiz__plan-day">' +
      esc(r.day) +
      '</span></div>' +
      '<div class="im8-welcome-quiz__plan-billed">' +
      esc(r.billed) +
      '</div>' +
      priceNote +
      '<div class="im8-welcome-quiz__plan-perks">' +
      '<span>✓ Exclusive Access to 90 Day IM8 Transformation Program</span>' +
      '<span>✓ Free Welcome Kit (US$97 in value)</span>' +
      '</div>' +
      '</div>';

    return (
      '<div class="im8-welcome-quiz__result">' +
      '<div class="im8-welcome-quiz__result-scroll">' +
      hero +
      '<div class="im8-welcome-quiz__reviews">★★★★★ <strong>4.8</strong> from ' +
      REVIEW_COUNT +
      ' Reviews · 54M+ servings</div>' +
      '<div class="im8-welcome-quiz__result-eye">' +
      esc(r.eye) +
      '</div>' +
      '<h2 class="im8-welcome-quiz__result-name">' +
      esc(r.name) +
      '</h2>' +
      '<p class="im8-welcome-quiz__result-sub">Your match — built from your answers.</p>' +
      '<p class="im8-welcome-quiz__result-why">' +
      esc(r.why) +
      '</p>' +
      '<div class="im8-welcome-quiz__pills">' +
      pills +
      '</div>' +
      plan +
      '<button type="button" class="im8-welcome-quiz__result-cta" data-action="add-to-cart">Start my 90-day program — 30% off</button>' +
      '<p class="im8-welcome-quiz__result-fine">Quarterly subscription, preselected · 90-day money-back guarantee · Free shipping · Cancel anytime</p>' +
      '<p class="im8-welcome-quiz__result-quote">77% of customers subscribe quarterly — built for the long term.</p>' +
      up +
      note +
      '<button type="button" class="im8-welcome-quiz__restart" data-action="restart">Retake the quiz</button>' +
      '<p class="im8-welcome-quiz__fda">† 12-week randomized controlled trial, NCT06655597. These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease.</p>' +
      '</div>' +
      '</div>'
    );
  };

  WelcomeQuiz.prototype.render = function () {
    var html = '';
    if (this.state.step === 'intro') html = this.renderIntro();
    else if (this.state.step === 'q') html = this.renderQuiz();
    else if (this.state.step === 'amb') html = this.renderAmbassadors();
    else if (this.state.step === 'sab') html = this.renderDoctors();
    else if (this.state.step === 'calc') html = this.renderCalc();
    else html = this.renderResult();

    this.root.innerHTML =
      '<div class="im8-welcome-quiz__frame im8-welcome-quiz__frame--' +
      this.state.step +
      '">' +
      html +
      '</div>';
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-im8-welcome-quiz]').forEach(function (el) {
      var configEl = el.querySelector('[data-im8-welcome-quiz-config]');
      var config = {};
      if (configEl) {
        try {
          config = JSON.parse(configEl.textContent || '{}');
        } catch (err) {
          config = {};
        }
      }
      new WelcomeQuiz(el, config);
    });
  });
})();
